// extracted by mini-css-extract-plugin
module.exports = {"root":"Q_1qgoRU","descriptionText":"e30mKDkk","titleText":"iCFCXHab"};